<template>
  <div id="confirm-registration-form">
    <Form
      :header="header"
      :model="model"
      :schema="schema"
      :options="options"
      :buttons="buttons"
      :messages="messages"
      @form_submit="form_submit"
      @button_click="button_click"></Form>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";
import { AUTH_ACTIONS, LOCAL_STORAGE } from "../../utils/consts";

var validator_messages = get_validator_messages();

export default {
  name: "ConfirmRegistration",
  components: {
    Form
  },
  data() {
    return {
      buttons: [
        {
          name: "confirm",
          style_classes: "float-right mb-1",
          buttons: [
            {
              label: "Zweryfikuj",
              variant: "success",
              type: "submit",
              name: "confirm",
              icon: "shield-lock-fill",
              spinner: true,
              spinner_id: "verify-spinner"
            }
          ]
        },
        {
          name: "resend_verification_code",
          style_classes: "float-right btn-group-sm mt-1",
          buttons: [
            {
              label: "Wyślij ponownie kod weryfikacyjny",
              variant: "primary",
              type: "button",
              name: "resend_verification_code"
            }
          ]
        }
      ],
      header: {
        title: "Zweryfikuj rejestrację.",
        icon: "shield-lock-fill"
      },
      model: {
        email: null,
        password: null,
        code: null
      },
      messages: [
        {
          variant: "primary",
          label:
            "Wysłaliśmy do Ciebie wiadomość z kodem weryfikacyjnym. Wprowadź kod i ustaw hasło aby zacząć korzystać z produktu."
        }
      ],
      options: {
        validateAsync: true
      },
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "email",
                label: "Email",
                model: "email",
                required: true,
                validator: [
                  VueFormGenerator.validators.email.locale(validator_messages)
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "password",
                label: "Ustaw Hasło",
                model: "password",
                hint:
                  "Hasło musi zawierać co najmniej 8 znaków, 1 dużą literę, 1 małą literę, 1 cyfrę oraz 1 znak specjalny(np. !, @, #, $, %).",
                required: true,
                autocomplete: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "text",
                label: "Kod",
                model: "code",
                hint: "Kod otrzymany w wiadomości mailowowej",
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    form_submit: function (model) {
      const spinner = document.getElementById("verify-spinner");
      spinner.style.display = "block";
      Vue.CognitoAuth.confirm_sign_up(
        {
          username: model.email,
          confirmation_code: model.code,
          password: model.password
        },
        this.confirmation_success,
        this.confirmation_failure
      );
    },
    confirmation_success: function () {
      this.messages = [];
      this.$localStorage.set(
        LOCAL_STORAGE.executed_auth_action,
        AUTH_ACTIONS.account_activation
      );
      this.$localStorage.set(
        LOCAL_STORAGE.activated_account_email,
        this.model.email
      );
      this.$router.push({ name: "Login" });
    },
    confirmation_failure: function (err) {
      const spinner = document.getElementById("verify-spinner");
      spinner.style.display = "None";
      console.log("Error:", err);
      this.messages = [];
      this.messages = [
        {
          label: err,
          variant: "danger"
        }
      ];
    },
    resend_verification_code_failure: function (err) {
      console.log("Error:", err);
      this.messages = [];
      this.messages = [
        {
          label: err,
          variant: "danger"
        }
      ];
    },
    resend_verification_code_success: function (data) {
      this.messages = [
        {
          label: data.message,
          variant: "success"
        }
      ];    
    },
    button_click: function (button_name) {
      if (button_name == "resend_verification_code") {
        Vue.CognitoAuth.resend_verification_code(
          {
            username: this.model.email
          },
          this.resend_verification_code_success,
          this.resend_verification_code_failure
        );
      }
    }
  }
};
</script>

<style>
@media (min-width: 768px) {
  #confirm-registration-form .form-container {
    max-width: 520px;
  }
}
</style>
